import { container, rectModule, registerRectGraphic } from "@visactor/vrender-core";

import { browser } from "./env";

import { rectCanvasPickModule } from "../picker/contributions/canvas-picker/rect-module";

import { rectMathPickModule } from "../picker/contributions/math-picker/rect-module";

function _registerRect() {
    _registerRect.__loaded || (_registerRect.__loaded = !0, registerRectGraphic(), container.load(rectModule), 
    container.load(browser ? rectCanvasPickModule : rectMathPickModule));
}

_registerRect.__loaded = !1;

export const registerRect = _registerRect;
//# sourceMappingURL=register-rect.js.map